module.exports = "<h1 class=\"typo-display-1\">Not supported</h1>\r\n<p class=\"margin-md\">\r\n  We are sorry, but you are using a web browser that is currently not supported by the application.\r\n  Please download or update to one of the following browsers.\r\n</p>\r\n<p class=\"margin-md text-align-center\">\r\n  <a class=\"app-error__browser-icon\"\r\n      href=\"http://www.google.com/chrome/?hl=es-419\"\r\n      title=\"Google Chrome\"\r\n      target=\"_blank\"><img src=\"./chrome/icon.png\"></a>\r\n</p>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/fanconsultores/components/app/notsupported/template.html
// module id = 2704
// module chunks = 0